module.exports = __webpack_public_path__ + "static/media/Auto_orange.754b8c25.svg";